import { useSelector } from 'react-redux';
import { ManagerRole } from '~/constants/clientTypes.ts';
import { RootState } from '~/store/store';
import { TUserRole } from '~/store/users/types';

type TUserRoleReturnValues = {
  roles: TUserRole;
  isClientLogin: boolean;
  isManagerLogin: boolean;
  isAssetManager: boolean;
  isManager: boolean;
  isObserver: boolean;
  isSupervisor: boolean;
  isUakdoAdmin: boolean;
  canViewIdentification: boolean;
  isPersonalDataManager: boolean;
  isCallCenterOperator: boolean;
  isPersonalDataObserver: boolean;
  isCovenantsBranchManager: boolean;
  canViewServices: boolean;
  canViewReports: boolean;
  canViewPersonalData: boolean;
};

export const useGetUserRole = (): TUserRoleReturnValues => {
  const roles = useSelector((state: RootState) => state.users.user?.roles as TUserRole);
  const { isAssetManager, isManagerLogin, isClientLogin } = useSelector(
    (state: RootState) => state.users
  );

  const isManager = !!roles?.includes(ManagerRole.manager);
  const isObserver = !!roles?.includes(ManagerRole.observer);
  const isSupervisor = !!roles?.includes(ManagerRole.supervisor);
  const isPersonalDataManager = !!roles?.includes(ManagerRole.personal_data_manager);
  const isCallCenterOperator = !!roles?.includes(ManagerRole.call_center_operator);
  const isCovenantsBranchManager = !!roles?.includes(ManagerRole.covenants_branch_manager);
  const isUakdoAdmin = !!roles?.includes(ManagerRole.uakdo_administrator);
  const canViewIdentification = !!(isManager || isObserver || isSupervisor);
  const isPersonalDataObserver = !!(isPersonalDataManager || isCallCenterOperator);
  const canViewServices = !!(isObserver || isPersonalDataManager || isCallCenterOperator);
  const canViewReports = !!(isObserver || isCallCenterOperator);
  const canViewPersonalData = !!(isPersonalDataManager || isCallCenterOperator);

  return {
    roles,
    isClientLogin,
    isManagerLogin,
    isAssetManager,
    isSupervisor,
    isManager,
    isObserver,
    isUakdoAdmin,
    canViewIdentification,
    isPersonalDataManager,
    isCallCenterOperator,
    isPersonalDataObserver,
    isCovenantsBranchManager,
    canViewServices,
    canViewReports,
    canViewPersonalData,
  };
};

export default useGetUserRole;
